import {
    EDIT_ARTIST_EVENT,
    EDIT_HOST_EVENT,
    HOST_RAISE_HAND,
    HOST_DECLINES,
    HOST_PROPOSES,
    UPDATE_EVENT_ERROR,
    GET_EVENTS_OFFERED_TO_HOST,
    GET_EVENTS_NEAR_ME_TO_HOST,
    GET_EVENT_BY_ID,
    GET_DISCOVERABLE_EVENTS,
    GET_THIS_ARTIST_BOOKING_EVENTS,
    GET_ALL_EVENTS,
    GET_THIS_ARTIST_EVENTS,
    ARTIST_VIEWED_HOST_OFFER,
    ARTIST_ACCEPTED_HOST_OFFER,
    ARTIST_DECLINED_HOST_OFFER,
    EVENTS_ERROR,
    LOGOUT,
    DELETE_ARTIST_EVENT,
    DELETE_HOST_EVENT,
    DELETE_ADMIN_EVENT,
    ARTIST_REVIEWS_HOST,
    HOST_REVIEWS_EVENT,
    HOST_UPLOADED_FILES,
    CANCEL_EVENT,
    UPDATE_EVENT_DATE,
    VERIFY_EVENT_ATTENDEE,
} from '../actions/types';

const initialState = {
    myHostEvents: [],
    myArtistEvents: [],
    events: [],
    eventById: null,
    discoverableEvents: [],
    nearMeToHost: [],
    loading: true,
    msg: {},
    error: {},
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_EVENTS_NEAR_ME_TO_HOST:
            return {
                ...state,
                nearMeToHost: payload,
                loading: false,
            };
        case GET_EVENT_BY_ID: {
            // Preserve flags like isAttending/numAttendees when incoming payload omits them
            const existing =
                state.eventById && state.eventById._id === payload._id
                    ? state.eventById
                    : (state.nearMeToHost || []).find(
                          (e) => e._id === payload._id
                      );
            const mergedPayload = existing
                ? {
                      ...existing,
                      ...payload,
                      // If new payload lacks isAttending, keep the existing value
                      isAttending:
                          typeof payload.isAttending !== 'undefined'
                              ? payload.isAttending
                              : existing.isAttending,
                      // If new payload lacks numAttendees, keep the existing value
                      numAttendees:
                          typeof payload.numAttendees !== 'undefined'
                              ? payload.numAttendees
                              : existing.numAttendees,
                      // Keep owner/host attendee list if a mutation response omits it
                      isOwner:
                          typeof payload.isOwner !== 'undefined'
                              ? payload.isOwner
                              : existing.isOwner,
                      attendeeSummaries:
                          typeof payload.attendeeSummaries !== 'undefined'
                              ? payload.attendeeSummaries
                              : existing.attendeeSummaries,
                  }
                : payload;

            const idx = state.nearMeToHost
                ? state.nearMeToHost.findIndex(
                      (e) => e._id === mergedPayload._id
                  )
                : -1;

            return {
                ...state,
                eventById: mergedPayload,
                nearMeToHost:
                    state.nearMeToHost && idx > -1
                        ? state.nearMeToHost.map((e) =>
                              e._id === mergedPayload._id
                                  ? { ...e, ...mergedPayload }
                                  : e
                          )
                        : state.nearMeToHost
                          ? [...state.nearMeToHost, mergedPayload]
                          : [mergedPayload],
                myHostEvents: Array.isArray(state.myHostEvents)
                    ? state.myHostEvents.map((e) =>
                          e._id === mergedPayload._id
                              ? { ...e, ...mergedPayload }
                              : e
                      )
                    : state.myHostEvents,
                loading: false,
            };
        }

        case GET_DISCOVERABLE_EVENTS:
            return {
                ...state,
                discoverableEvents: payload,
                loading: false,
            };
        case GET_EVENTS_OFFERED_TO_HOST:
        case EDIT_HOST_EVENT:
            return {
                ...state,
                myHostEvents: payload,
                loading: false,
            };
        case GET_THIS_ARTIST_BOOKING_EVENTS:
            return {
                ...state,
                events: payload,
                loading: false,
            };
        case GET_ALL_EVENTS:
            return {
                ...state,
                adminEvents: payload,
                loading: false,
            };
        case GET_THIS_ARTIST_EVENTS:
            return {
                ...state,
                myArtistEvents: payload,
                loading: false,
            };
        case EDIT_ARTIST_EVENT:
            let update = state.myArtistEvents.findIndex(
                (artistEvent) => artistEvent._id === payload._id
            ); //if -1 then insert
            // console.log('update: ', update);
            return {
                ...state,
                myArtistEvents:
                    update > -1
                        ? state.myArtistEvents.map((myArtistEvent) =>
                              myArtistEvent._id === payload._id
                                  ? payload //updates an event in the state
                                  : myArtistEvent
                          )
                        : [...state.myArtistEvents, payload], //inserts an event into the state
                loading: false,
            };
        case ARTIST_REVIEWS_HOST:
            // console.log('payload', payload);
            return {
                ...state,
                myArtistEvents: state.myArtistEvents.map((myArtistEvent) => {
                    if (myArtistEvent._id === payload.eventId) {
                        myArtistEvent.artistReviewOfHost = { ...payload };
                        return myArtistEvent;
                    } else {
                        return myArtistEvent;
                    }
                }),
                loading: false,
            };
        case HOST_REVIEWS_EVENT:
            // console.log('payload', payload);
            return {
                ...state,
                myHostEvents: state.myHostEvents.map((myHostEvent) => {
                    if (myHostEvent._id === payload.eventId) {
                        myHostEvent.hostReviewOfEvent = { ...payload };
                        return myHostEvent;
                    } else {
                        return myHostEvent;
                    }
                }),
                loading: false,
            };
        case HOST_UPLOADED_FILES:
            console.log('HOST_UPLOADED_FILES payload', payload);
            console.log(
                'HOST_UPLOADED_FILES payload.uploadedFiles',
                payload.uploadedFiles
            );
            return {
                ...state,
                myHostEvents: state.myHostEvents.map((myHostEvent) => {
                    if (myHostEvent._id === payload._id) {
                        myHostEvent.uploadedFiles = [...payload.uploadedFiles];
                        return myHostEvent;
                    } else {
                        return myHostEvent;
                    }
                }),
                loading: false,
            };
        case ARTIST_VIEWED_HOST_OFFER:
        case ARTIST_ACCEPTED_HOST_OFFER:
        case ARTIST_DECLINED_HOST_OFFER:
            return {
                ...state,
                myArtistEvents: state.myArtistEvents.map(
                    (myArtistEvent) =>
                        myArtistEvent._id === payload._id
                            ? payload
                            : myArtistEvent //updates an event in the state
                ),
                loading: false,
            };
        case CANCEL_EVENT:
            // console.log('payload', payload);
            return {
                ...state,
                myArtistEvents: state.myArtistEvents.map((myArtistEvent) => {
                    if (myArtistEvent._id === payload._id) {
                        return {
                            ...myArtistEvent,
                            status: 'CANCELED',
                            canceledReason: payload.canceledReason,
                            canceledBy: payload.canceledBy,
                            canceledDate: payload.canceledDate,
                        };
                    } else {
                        return myArtistEvent;
                    }
                }),
                myHostEvents: state.myHostEvents.map((myHostEvent) => {
                    if (myHostEvent._id === payload._id) {
                        return {
                            ...myHostEvent,
                            status: 'CANCELED',
                            canceledReason:
                                payload.canceledReason || 'Event canceled',
                            canceledBy: payload.canceledBy || 'Unknown',
                            canceledDate:
                                payload.canceledDate ||
                                new Date().toISOString(),
                        };
                    } else {
                        return myHostEvent;
                    }
                }),
                loading: false,
            };
        case DELETE_ARTIST_EVENT:
            return {
                ...state,
                myArtistEvents: state.myArtistEvents.filter(
                    (myArtistEvent) =>
                        myArtistEvent._id !== payload && myArtistEvent //deletes an event from the state
                ),
                loading: false,
            };
        case DELETE_HOST_EVENT:
            return {
                ...state,
                myHostEvents: state.myHostEvents.filter(
                    (myHostEvent) => myHostEvent._id !== payload && myHostEvent //deletes an event from the state
                ),
                loading: false,
            };
        case DELETE_ADMIN_EVENT:
            return {
                ...state,
                adminEvents: state.adminEvents.filter(
                    (adminEvent) => adminEvent._id !== payload && adminEvent //deletes an event from the state
                ),
                loading: false,
            };
        case HOST_RAISE_HAND:
            let newNearMeToHost = state.nearMeToHost.filter(
                (eventNearMeToHost) => {
                    if (eventNearMeToHost._id !== payload._id) {
                        return eventNearMeToHost;
                    }
                }
            );
            // console.log('newNearMeToHost', newNearMeToHost);
            return {
                ...state,
                myHostEvents: [...state.myHostEvents, payload],
                nearMeToHost: newNearMeToHost,

                loading: false,
            };
        case HOST_DECLINES: {
            const nearMeToHost = state.nearMeToHost || [];
            const eventIsLoaded = nearMeToHost.some(
                (eventNearMeToHost) =>
                    eventNearMeToHost._id === payload._id
            );

            return {
                ...state,
                nearMeToHost: eventIsLoaded
                    ? nearMeToHost.map((eventNearMeToHost) =>
                          eventNearMeToHost._id === payload._id
                              ? { ...eventNearMeToHost, ...payload }
                              : eventNearMeToHost
                      )
                    : [payload, ...nearMeToHost],
                loading: false,
            };
        }

        case HOST_PROPOSES:
            return {
                ...state,
                myHostEvents: state.myHostEvents.map((myHostEvent) => {
                    if (myHostEvent._id === payload._id) {
                        return payload;
                    } else return myHostEvent;
                }),
                loading: false,
            };
        case UPDATE_EVENT_DATE:
            return {
                ...state,
                myHostEvents: state.myHostEvents.map((myHostEvent) =>
                    myHostEvent._id === payload._id
                        ? { ...myHostEvent, bookingWhen: payload.bookingWhen }
                        : myHostEvent
                ),
                myArtistEvents: state.myArtistEvents
                    ? state.myArtistEvents.map((myArtistEvent) =>
                          myArtistEvent._id === payload._id
                              ? {
                                    ...myArtistEvent,
                                    bookingWhen: payload.bookingWhen,
                                }
                              : myArtistEvent
                      )
                    : state.myArtistEvents,
                loading: false,
            };
        case UPDATE_EVENT_ERROR:
        case EVENTS_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case VERIFY_EVENT_ATTENDEE: {
            const eventId = payload && payload.eventId;
            const attendeeSummaries = payload && payload.attendeeSummaries;
            const numAttendees = payload && payload.numAttendees;
            const patchEvent = (existing) => {
                if (!existing || String(existing._id) !== String(eventId)) {
                    return existing;
                }
                return {
                    ...existing,
                    attendeeSummaries:
                        typeof attendeeSummaries !== 'undefined'
                            ? attendeeSummaries
                            : existing.attendeeSummaries,
                    numAttendees:
                        typeof numAttendees !== 'undefined'
                            ? numAttendees
                            : existing.numAttendees,
                };
            };
            return {
                ...state,
                eventById: patchEvent(state.eventById),
                myHostEvents: Array.isArray(state.myHostEvents)
                    ? state.myHostEvents.map((myHostEvent) =>
                          patchEvent(myHostEvent)
                      )
                    : state.myHostEvents,
                loading: false,
            };
        }
        case LOGOUT:
            return {
                ...state,
                nearMeToHost: [],
                myArtistEvents: [],
                myHostEvents: [],
                adminEvents: [],
                discoverableEvents: [],
            };
        default:
            return state;
    }
}
